import { BehaviorSubject } from 'rxjs';

import { AsyncPipe } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { LogotypeComponent } from '../../../../core/components/logotype/logotype.component';
import { IAsyncState } from '../../../../core/interfaces/async-state.interface';
import { ShippingStatusEnum } from '../../enums/shipping-status.enum';
import { IShipping } from '../../interfaces/shipping.interface';
import { ShippingStopKindPipe } from '../../pipes/shipping-stop-kind.pipe';
import { ShippingService } from '../../services/shipping.service';
import { ShippingFailedComponent } from '../shipping-failed/shipping-failed.component';
import { ShippingLoaderComponent } from '../shipping-loader/shipping-loader.component';

@Component({
  selector: 'peca-shipping-confirmation',
  templateUrl: './shipping-confirmation.component.html',
  styleUrl: './shipping-confirmation.component.scss',
  imports: [ShippingStopKindPipe, LogotypeComponent, AsyncPipe, ShippingLoaderComponent, ShippingFailedComponent],
})
export class ShippingConfirmationComponent {
  @Input({ required: true })
  shipping!: IShipping;

  @Output()
  reload = new EventEmitter<void>();

  activatedRoute = inject(ActivatedRoute);
  shippingService = inject(ShippingService);
  shippingConfirmationState$ = new BehaviorSubject<IAsyncState<void>>({ loading: false });

  get shippingReferenceSnapshot() {
    return this.activatedRoute.snapshot.paramMap.get('shippingReference') as string;
  }

  onClickConfirm() {
    const payload = { orderId: this.shippingReferenceSnapshot, status: ShippingStatusEnum.COLLECTION_ROUTE };

    this.shippingConfirmationState$.next({ loading: true });
    this.shippingService.webhook(payload, this.shippingReferenceSnapshot).subscribe({
      next: () => this.reload.emit(),
      error: () => this.shippingConfirmationState$.next({ failed: true }),
    });
  }

  onRetry() {
    this.onClickConfirm();
  }
}
